'use strict';
class TranslationService {
    constructor(CoreCommon, $interpolate, $translate, $q){
        this.dictionary = {};
        this.language = 'en';
        this.CoreCommon = CoreCommon;
        this.$translate = $translate;
        this.$interpolate = $interpolate;
        this.$q = $q;

        this.untranslatedWrapper = '@@';
        this.exposeUntranslatedStrings = false;
    }

    registerDictionary(data){
        this.dictionary = angular.merge(this.dictionary, data);
        this.dictionaryReady = true;
    }

    setLanguage(lang){
        if(this.CoreCommon.isUsable(lang)){
            this.language = lang;
            this.$translate.use(lang);
        } else {
            throw new Error('Invalid language selected');
        }
    }

    getLanguage() {
        return this.language;
    }

    isReady() {
        return this.dictionaryReady && !$.isEmptyObject(this.dictionary);
    }

    getDictionaryString(text) {
        if(text === undefined || text === null || text === '') {
            return text;
        }

        if (typeof this.dictionary[text] !== 'undefined' && this.dictionary[text] !== '') {
            return this.dictionary[text];
        } else {
            return (this.exposeUntranslatedStrings ? this.untranslatedWrapper + text + this.untranslatedWrapper : text);
        }
    }

    getLocalizedString(text, scope, waitForTranslation) {
        var localizedString;

        localizedString = this.getDictionaryString(text);

        if (scope) {
            localizedString = this.getPostTranslationInterpolatedText(localizedString, scope);
        }

        return waitForTranslation ? this.$q.when(localizedString) : localizedString;
    }

    getLocalizedStringAsync(text, scope) {
        return this.waitForTranslations().then(()=> {
            return this.getLocalizedString(text, scope, false);
        });
    }

    waitForTranslations(){
        return this.$q.when(); //legacy support, we don't need this promise
    }

    getPostTranslationInterpolatedText(text, scope) {
        if(text === null || text === undefined) {
            return text;
        }

        // first replace swaps out matching double square brackets for curly brackets (disregarding spaces) - Example: "[ [place.holder [1 ]]     ]" -> "{{place.holder [1 ]}}"
        // second replace removes all whitespace within the double curly brackets - Example: "{{place.holder [1 ]}}" -> "{{place.holder[1]}}"
        // this should protect us against bad translation files that introduce spaces and cause interpolation to fail (bad side effects) - GYDA-5299
        // sorry, but you're sadly out of luck if you really want to surround a interpolated string with square or curly braces...
        return this.$interpolate(text.replace(/(\[ *\[)(.*?)(\] *\])(?! *])/g, '{{$2}}').replace(/[ ]+(?=[^{}]*}})/g, ''))(scope);
    }
}
angular.module('MW.Framework.TranslationService', ['MW.Framework.CoreCommon', 'pascalprecht.translate']).service('translationService', ['CoreCommon', '$interpolate', '$translate', '$q', TranslationService]);
